import React, { useState, useMemo, useContext } from 'react';
import { Grid, Typography, ToggleButton } from '@mui/material';
import { styled } from "@mui/material/styles";
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone';
import { WindowSizeContext } from '../../../../common/context/WindowSizeContext';
// import { TABLE_NAME } from "../hooks";

// Define the available call‑out options as an array so that we can iterate over them
const options = [
    {
        value: "storeDisplay",
        label: "Store Display:",
        icon: <StorefrontTwoToneIcon />,
        iconColor: "#EA324C",
    },
    {
        value: "stockProblem",
        label: "Stock Problem:",
        icon: <Inventory2TwoToneIcon />,
        iconColor: "#F2AC42",
    },
    {
        value: "orderSettings",
        label: "Order Setting:",
        icon: <ContentPasteSearchTwoToneIcon />,
        iconColor: "#1649AE",
    },
    {
        value: "rentableValue",
        label: "Rentable Article:"
    }
];

const NewToggleButton = styled(ToggleButton)(({
    color: '#0a4fb4',
    backgroundColor: '#fff',
    "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor: '#0a4fb4',
        color: '#fff'
    },
    textTransform: 'capitalize',
    fontWeight: 'light',
}))

export default function CallOutsFilter({ onPillSelectChange, value }) {
    const [selectedCallOuts, setSelectedCallOuts] = useState({
        storeDisplay: true,
        stockProblem: true,
        orderSettings: true,
        rentableValue: true,
        noCallOuts: true
    });

    const handleCallOutToggle = (callOutType) => {
        const newSelectedCallOuts = {
            ...selectedCallOuts,
            [callOutType]: !selectedCallOuts[callOutType]
        };
        setSelectedCallOuts(newSelectedCallOuts);

        // Pass the selected call-out types to parent
        const selectedTypes = Object.keys(newSelectedCallOuts).filter(key => newSelectedCallOuts[key]);
        onPillSelectChange(selectedTypes, 'callOuts');
    };
    const windowSize = useContext(WindowSizeContext);

    const pillButtons = options.map((option) => {
        const isSelected = selectedCallOuts[option.value];
        return (
            <Grid item key={option.value} sm xs>
                <NewToggleButton
                    value={option.value}
                    onClick={() => handleCallOutToggle(option.value)}
                    selected={isSelected}
                    sx={{
                        paddingY: '1.3rem',
                        width: '100%',
                        height: '2.5rem',
                        borderRadius: '1.5rem',
                    }}
                >
                    {option.icon && <span style={{ marginRight: '.3rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', padding: '0.4rem', borderRadius: '50%', width: '2rem', height: '2rem', color: option.iconColor }}>{option.icon}</span>}
                    {option.label && <span style={{ fontWeight: 'normal', marginRight: '.3rem', textWrap: 'nowrap' }}>{option.label}</span>}
                    <span style={{ fontWeight: 'bold', marginRight: '.2rem', fontSize: '1rem', textWrap: 'nowrap' }}>{value ? value[option.value] : option.value} SKUs</span>
                </NewToggleButton>
            </Grid>
        );
    })

    return (
        <>
            <Grid container my={.8} sm xs={12} display={'flex'} alignItems="center">
                <Typography variant="body1" sx={{ mr: 2, color: '#000000', textWrap: 'nowrap' }}>Select Call-Out:</Typography>
                <Grid container xs={12} sm={8} md={{ sx: { mx: 2 } }} spacing={1} direction="horizontal" alignItems="center" sx={{ flex: 1 }}>
                    {pillButtons}
                </Grid>
            </Grid>
        </>
    );
}